import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { usePrevious } from "../../../../../utilities/hooks";
import "./style.css";

/**
 * @name ToggleCheckBox
 * @function
 * @description Renders a Switch Toggle Button
 * @returns {JSX}
 * @param {*} props
 */
function ToggleCheckBox(props) {
  const [checked, setChecked] = useState(props.checked),
    [value, setValue] = useState(props.value),
    prevChecked = usePrevious(props.checked);

  useEffect(() => {
    if (prevChecked !== props.checked) setChecked(props.checked);

    return () => {
      // check for change in values
      if (props.value !== value) {
        setValue(props.value);
        setChecked(props.checked);
      }
    };
  });

  /**
   * @name handleChange
   * @method
   * @description Controls the state of the checkbox
   */
  const handleChange = (e) => {
    setChecked(!checked);
    if (props.onClick) props.onClick(encodeURI(props.value), !checked);
  };

  return (
    <div className="toggleCheck">
      <input
        id={props.id}
        type="checkbox"
        className="checkbox checkbox-global__input"
        value={props.value}
        checked={checked}
        onChange={handleChange}
        disabled={props.disabled}
        aria-label ={`${props.ariaLabel} ${props.value}`}
      />
      <label className="toggleCheck__title">{props.value}</label>
    </div>
  );
}

ToggleCheckBox.defaultProps = {
  checked: false,
  disabled: false,
  value: "",
};

ToggleCheckBox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

export default ToggleCheckBox;
